import React from 'react';

const TonerLevel = ({ nivel, cor = 'black',width = '18px', height = '50px', numeroserie = null, onClick, fontSize, sizeIcon , label = null}) => {
    const isNull = nivel === null || nivel === undefined;
    const altura = isNull ? 0 : Math.max(0, Math.min(Number(nivel) || 0, 100));
    const isEmpty = altura === 0 && !isNull;

    const corMap = {
        preto: { nivel: '#333', fundo: '#CFD8DC' },
        ciano: { nivel: '#0D47A1', fundo: '#B3E5FC' },
        magenta: { nivel: '#C2185B', fundo: '#FCE4EC' },
        amarelo: { nivel: '#FDD835', fundo: '#FFF8E1' },
    };

    const corData = corMap[cor.toLowerCase()] || corMap['preto'];

    return (
        <div
            
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: '65px',
                opacity: nivel === null ? 0.3 : 1,
                cursor : nivel !== null && onClick ? 'pointer' :''
            
            }}
            onClick={()=>{
                if(nivel !== null && onClick){
                    onClick()
                }
            }}
        >
            {numeroserie ? <span className='text-center text-sm pb-2'>{numeroserie}</span> : null }
            <div
                style={{
                    minWidth: width,
                    height: height,
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    backgroundColor: corData.fundo,
                    position: 'relative',
                    overflow: 'hidden',

                }}
            >
                {nivel !== null && altura > 0 ? 
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            borderRadius: '3px',
                            height: `${altura}%`,
                            background: corData.nivel,
                            animation: 'wave 2s infinite ease-in-out',
                            borderRadius: '0 0 6px 6px',
                        }}
                    />
                 : nivel == null ? null : 
                 <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '0 0 6px 6px',
                    fontSize : sizeIcon ? sizeIcon : '1rem', 
                    textAlign: 'center', 
                    display:'flex', 
                    alignContent:'center', 
                    justifyContent :'center', 
                    alignItems:'center',
                    animation: 'blink 1s infinite',
                }}>
                 ⚠️
                </div> 
                 }
            </div>
                 <div style={{ 
                        fontSize: fontSize ? fontSize : '0.5rem', 
                        marginTop: '3px', 
                        paddingLeft : '1px', 
                        paddingRight : '1px', 
                        width:'32px', 
                        textAlign:'center',                     
                        animation: nivel === 0 ? 'blink 2s infinite' : '', }}>
                 {nivel !== null ? nivel+'%' : 'n/d'}
                </div>

                {
                    label !== null ? <div style={{ 
                        fontSize: fontSize ? fontSize : '0.5rem', 
                        marginTop: '3px', 
                        paddingLeft : '1px', 
                        paddingRight : '1px', 
                        width:'100%', 
                        textAlign:'center',                     
                         }}>
                 {label}
                </div> : null
                }
            
        

           
        </div>
    );
};

export default TonerLevel;
